import { DatePipe, DOCUMENT } from '@angular/common';
import { Component, OnInit, Input, ViewChild, ElementRef, Directive, OnDestroy, HostListener, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { max } from 'rxjs/operators';
import { ApiService } from 'src/app/core/helpers/apiClient';
//import Swal from 'sweetalert2';
import appSettings from '../../../assets/settings/system.settings.json'
import { ChartType } from './chart-model/apex.model';
import { TreeviewItem, TreeviewConfig } from 'ngx-treeview';
import * as c3 from 'c3';
import {
  ApexAxisChartSeries, ApexChart, ChartComponent, ApexDataLabels, ApexPlotOptions, ApexResponsive, ApexXAxis, ApexLegend, ApexFill
} from "ng-apexcharts";
import { ConfigService } from "src/app/core/services/getSettings";


export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  responsive: ApexResponsive[];
  xaxis: ApexXAxis;
  legend: ApexLegend;
  fill: ApexFill;
};


@Component({
  selector: 'milldashboard-shared',
  templateUrl: './milldashboard-shared.component.html',
  styleUrls: ['./milldashboard-shared.component.scss'],
  providers: [DatePipe]
})
export class MillDashboardSharedComponent implements OnDestroy {
  protected appSettings = ConfigService.settings;

  //#region SystemSettings
  apiPath = `${this.appSettings.apiPath.crop}/api/milldashboard`;

  //timer
  timerValue;

  //Drop Down
  regionList: any[];
  businessUnitList: any[];
  operatingUnitList: TreeviewItem[] = [];
  dateList = [
    { "index": 1, "dateV": "1 to 7", "from": 1, "to": 7 },
    { "index": 2, "dateV": "8 to 15", "from": 8, "to": 15 },
    { "index": 3, "dateV": "16 to 23", "from": 16, "to": 23 },
    { "index": 4, "dateV": "24 to 31", "from": 24, "to": 31 }];
  chartDateSel = 0;

  //Chart
  SubChartLabel;
  totalRecords: number;
  startIndex: number;
  endIndex: number;
  page: number = 1;
  pageSize: number = 10;
  showChartDetailsDetails: boolean[] = [];
  chartDetailsData;
  chardDetailsDataList;

  // OER/KER Chart
  millProductivityOerKerChartData;
  millProductivityKerChartData;
  millProductivityOerChartData;
  millProductivityOerKerChartDetailsCollapsed: boolean = true;

  //CPO/PK Chart
  millProductivityCpoPkChartData;
  millProductivityCpoPkChartDetailsCollapsed: boolean = true;

  //FFB Chart
  millProductivityFfbChartData;
  millProductivityFfbChartData1;
  millProductivityFfbChartDetailsCollapsed: boolean = true;
  
  //Pie Chart
  millProducitivtyPieChartData;
  millProductivityPieChartDetailsCollapsed: boolean=true;

  linewithDataChart;
  showLineChart: boolean = false;
  chartData: any[];
  screenWidth;
  chartTitle;
  cartSelLabel;
  chartLabelColor;

  //ST
  StMillList =[];
  DtMillList =[];
  St1MillList =[];
  Dt1MillList =[];
  St2MillList =[];
  Dt2MillList =[];
  ismultipleou: boolean = true;
  //CurrentDate
  newcurrentDate;
  yesterdayDate;

  //Unit
  regionSelVal;
  businessSelVal;
  operatingSelVal = [];
  showSingle: boolean = false;
  operatingSelSingleVal;


  //Text
  yphText = "Yield Per Hectare Month Todate";
  mtdText = "Month Todate";
  ytdText = "Year Todate";
  oerText = "Oil Extraction Rate (OER)"
  kerText = "Kernel Extraction Rate (KER)"
  yphmonthText = "Oil Extraction Rate (OER) (Month)";
  yphyearText = "Oil Extraction Rate (OER) (Year)";
  cpoDay = "CPO (Day)"


  yphTexth = "Yield Per Hectare This Month";
  mtdTexth = "Month History Crop";
  ytdTexth = "Year History Crop";

  dailyoerTextCompare1 = "Oil Extraction Rate (OER)";
  dailyoerTextCompare2 = "Oil Extraction Rate (OER)";
  dailykerTextCompare1 = "Kernel Extraction Rate (KER)";
  dailykerTextCompare2 = "Kernel Extraction Rate (KER)";
  dailycpoTextCompare1 = "Crude Palm Oil (CPO)"
  dailycpoTextCompare2 = "Crude Palm Oil (CPO)"
  dailypkTextCompare1 = "Palm Kernel (PK)"
  dailypkTextCompare2 = "Palm Kernel (PK)"
  dailystTextCompare1 = "Storage Tank (ST)"
  dailystTextCompare2 = "Storage Tank (ST)"
  dailydtTextCompare1 = "Dispatch Tank (DT)"
  dailydtTextCompare2 = "Dispatch Tank (DT)"
  dailyffbTextCompare1 = "Fresh Fruit Bunch (FFB)";
  dailyffbTextCompare2 = "Fresh Fruit Bunch (FFB)";
  dailykernelTextCompare1 = "Kernel Bunker (KB)";
  dailykernelTextCompare2 = "Kernel Bunker (KB)";
  monthlyoerTextCompare1 = "Oil Extraction Rate (OER)";
  monthlyoerTextCompare2 = "Oil Extraction Rate (OER)";
  monthlykerTextCompare1 = "Kernel Extraction Rate (KER)";
  monthlykerTextCompare2 = "Kernel Extraction Rate (KER)";
  monthlycpoTextCompare1 = "Crude Palm Oil (CPO)";
  monthlycpoTextCompare2 = "Crude Palm Oil (CPO)";
  monthlypkTextCompare1 = "Palm Kernel (PK)";
  monthlypkTextCompare2 = "Palm Kernel (PK)";
  monthlystTextCompare1 = "Storage Tank (ST)";
  monthlystTextCompare2 = "Storage Tank (ST)";
  monthlydtTextCompare1 = "Dispatch Tank (DT)";
  monthlydtTextCompare2 = "Dispatch Tank (DT)";
  monthlykernelTextCompare1 = "Kernel Bunker (KB)";
  monthlykernelTextCompare2 = "Kernel Bunker (KB)";
  monthlyffbTextCompare1 = "Fresh Fruit Bunch (FFB)";
  monthlyffbTextCompare2 = "Fresh Fruit Bunch (FFB)";

  yearlyoerTextCompare1 = "Oil Extraction Rate (OER)";
  yearlyoerTextCompare2 = "Oil Extraction Rate (OER)";
  yearlykerTextCompare1 = "Kernel Extraction Rate (KER)";
  yearlykerTextCompare2 = "Kernel Extraction Rate (KER)";
  yearlycpoTextCompare1 = "Crude Palm Oil (CPO)"
  yearlycpoTextCompare2 = "Crude Palm Oil (CPO)"
  yearlypkTextCompare1 = "Palm Kernel (PK)"
  yearlypkTextCompare2 = "Palm Kernel (PK)"
  yearlystTextCompare1 = "Storage Tank (ST)";
  yearlystTextCompare2 = "Storage Tank (ST)";
  yearlydtTextCompare1 = "Dispatch Tank (DT)";
  yearlydtTextCompare2 = "Dispatch Tank (DT)";
  yearlykernelTextCompare1 = "Kernel Bunker (KB)"
  yearlykernelTextCompare2 = "Kernel Bunker (KB)"  
  yearlyffbTextCompare1 = "Fresh Fruit Bunch (FFB)";
  yearlyffbTextCompare2 = "Fresh Fruit Bunch (FFB)";

  groupingType = 'day';

  //Date
  selDate = this.getYesterday();

  //Month
  selMonth = Number(this.datePipe.transform(new Date(), 'MM'));
  months: any[] = this.monthList(this.selMonth);
  selMonthData:any;

  //Year
  years: number[] = [];
  selYear = Number(this.datePipe.transform(new Date(), 'yyyy'));

  //Range
  selMonthFrom = Number(this.datePipe.transform(new Date(), 'MM'));
  selMonthTo = Number(this.datePipe.transform(new Date(), 'MM'));
  monthsFrom: any[] = this.monthList(this.selMonthFrom);
  monthsTo: any[] = this.monthList(this.selMonthFrom, this.selMonthTo);

  //Compare
  compareData = false;
  compareDate1ValChange = false;
  compareDate2ValChange = false;
  compareDate1 = this.getYesterday();
  compareDate2 = this.getYesterday();

  compareYearSel1 = Number(this.datePipe.transform(new Date(), 'yyyy'));
  compareMonthSel1 = Number(this.datePipe.transform(new Date(), 'MM'));
  compareMonthFromSel1 = Number(this.datePipe.transform(new Date(), 'MM'));
  compareMonthToSel1 = Number(this.datePipe.transform(new Date(), 'MM'));
  compareMonthsFrom1: any[] = this.monthList(this.compareMonthFromSel1);
  compareMonthsTo1: any[] = this.monthList(this.compareMonthFromSel1, this.compareMonthFromSel1);
  compareMonths1: any[] = this.monthList(this.compareMonthSel1);

  compareYearSel2 = Number(this.datePipe.transform(new Date(), 'yyyy'));
  compareMonthSel2 = Number(this.datePipe.transform(new Date(), 'MM'));
  compareMonthFromSel2 = Number(this.datePipe.transform(new Date(), 'MM'));
  compareMonthToSel2 = Number(this.datePipe.transform(new Date(), 'MM'));
  compareMonthsFrom2: any[] = this.monthList(this.compareMonthFromSel2);
  compareMonthsTo2: any[] = this.monthList(this.compareMonthFromSel2, this.compareMonthFromSel2);
  compareMonths2: any[] = this.monthList(this.compareMonthSel2);

  //Val
  //Daily OER
  dailyMt: number = 0;
  dailyBudget: number = 0;
  dailyVarPer: number = 0;
  dailyVarMt: number = 0;
  //Daily KER
  dailyKER: number = 0;
  dailyBudgetKER: number = 0;
  varianceKER: number = 0;
  //Daily FFB
  dailyFfbRecv: number = 0;
  dailyFfbPrcss: number = 0;
  dailyFfbBal: number = 0;
  //Daily CPO
  dailyCpoProd: number = 0;
  dailyCpoBal: number = 0;
  //Daily PK
  dailyPkProd: number = 0;
  dailyPkBal: number = 0;
  //Kernel Bunker
  kernalBunker: number = 0;


  //Monthly
  monthlyMt: number = 0;
  monthlyBudget: number = 0;
  monthlyVarPer: number = 0;
  monthlyVarMt: number = 0;

  //Yearly
  yearlyMt: number = 0;
  yearlyBudget: number = 0;
  yearlyVarPer: number = 0;
  yearlyVarMt: number = 0;

  //Quater
  QuaterList: any[];
  selectedQuarter;
  compareQuarter1;
  compareQuarter2;
  //YPH
  yphMt: number = 0;
  yphBudget: number = 0;
  yphVarPer: number = 0;
  yphVarMt: number = 0;
  //HA
  haMt: number = 0;

  //yphdayMDT
  yphMDT: number = 0;
  yphMDTBudget: number = 0;
  yphMDTVarPer: number = 0;
  yphMDTVarMt: number = 0;
  //yphmonthMDT
  yphMDTMonth: number = 0;
  yphMDTMonthBudget: number = 0;
  yphMDTMonthVarPer: number = 0;
  yphMDTMonthVarMt: number = 0;
  //yphyearMDT
  yphMDTYear: number = 0;
  yphMDTYearBudget: number = 0;
  yphMDTYearVarPer: number = 0;
  yphMDTYearVarMt: number = 0;

  //Compare1
  daily1Mt: number = 0;
  daily1Budget: number = 0;
  daily1VarPer: number = 0;
  daily1VarMt: number = 0;
  daily1KERMt: number = 0;
  daily1KERBudget: number = 0;
  daily1KERVarMt: number = 0;
  daily1cpoProd: number = 0;
  daily1cpoBal: number = 0;
  daily1PkProd: number = 0;
  daily1PkBal: number = 0;
  daily1FfbRecv: number = 0;
  daily1FfbPrcss: number = 0;
  daily1FfbBal: number = 0;
  daily1kernalBunker: number = 0;
  daily1stList: number = 0;
  daily1dtList: number = 0;

  monthly1Mt: number = 0;
  monthly1Budget: number = 0;
  monthly1VarPer: number = 0;
  monthly1VarMt: number = 0;
  monthly1KERMt: number = 0;
  monthly1KERBudget: number = 0;
  monthly1KERVarMt: number = 0;
  monthly1cpoProd: number = 0;
  monthly1cpoBal: number = 0;
  monthly1FfbRecv: number = 0;
  monthly1FfbPrcss: number = 0;
  monthly1FfbBal: number = 0;
  monthly1PkProd: number = 0;
  monthly1PkBal: number = 0;
  monthly1kernalBunker: number = 0;

  yearly1Mt: number = 0;
  yearly1Budget: number = 0;
  yearly1VarPer: number = 0;
  yearly1VarMt: number = 0;
  yearly1KERMt: number = 0;
  yearly1KERBudget: number = 0;
  yearly1KERVarMt: number = 0;
  yearly1cpoProd: number = 0;
  yearly1cpoBal: number = 0;
  yearly1FfbRecv: number = 0;
  yearly1FfbPrcss: number = 0;
  yearly1FfbBal: number = 0;
  yearly1PkProd: number = 0;
  yearly1PkBal: number = 0;
  yearly1kernalBunker: number = 0;

  //Compare2
  daily2Mt: number = 0;
  daily2Budget: number = 0;
  daily2VarPer: number = 0;
  daily2VarMt: number = 0;
  daily2KERMt: number = 0;
  daily2KERBudget: number = 0;
  daily2KERVarMt: number = 0;
  daily2cpoProd: number = 0;
  daily2cpoBal: number = 0;
  daily2PkProd: number = 0;
  daily2PkBal: number = 0;
  daily2FfbRecv: number = 0;
  daily2FfbPrcss: number = 0;
  daily2FfbBal: number = 0;
  daily2kernalBunker: number = 0;

  monthly2Mt: number = 0;
  monthly2Budget: number = 0;
  monthly2VarPer: number = 0;
  monthly2VarMt: number = 0;
  monthly2KERMt: number = 0;
  monthly2KERBudget: number = 0;
  monthly2KERVarMt: number = 0;
  monthly2cpoProd: number = 0;
  monthly2cpoBal: number = 0;
  monthly2FfbRecv: number = 0;
  monthly2FfbPrcss: number = 0;
  monthly2FfbBal: number = 0;
  monthly2PkProd: number = 0;
  monthly2PkBal: number = 0;
  monthly2kernalBunker: number = 0;

  yearly2Mt: number = 0;
  yearly2Budget: number = 0;
  yearly2VarPer: number = 0;
  yearly2VarMt: number = 0;
  yearly2KERMt: number = 0;
  yearly2KERBudget: number = 0;
  yearly2KERVarMt: number = 0;
  yearly2cpoProd: number = 0;
  yearly2cpoBal: number = 0;
  yearly2FfbRecv: number = 0;
  yearly2FfbPrcss: number = 0;
  yearly2FfbBal: number = 0;
  yearly2PkProd: number = 0;
  yearly2PkBal: number = 0;
  yearly2kernalBunker: number = 0;

  //new add field phase 2 
  cert_ffbreceived: number = 0;
  noncert_ffbreceived: number = 0;
  cert_ffbreceivedpercent: number = 0;
  noncert_ffbreceivedpercent: number = 0;

  cert_CPOProduction: number = 0;
  noncert_CPOProduction: number = 0;
  cert_CPOBalance: number = 0;
  noncert_CPOBalance: number = 0;

  cert_PKProduction: number = 0;
  noncert_PKProduction: number = 0;
  cert_PKBalance: number = 0;
  noncert_PKBalance: number = 0;

  totalST;
  totalDT;

  config = TreeviewConfig.create({
    hasAllCheckBox: true,
    hasFilter: true,
    hasCollapseExpand: true,
    decoupleChildFromParent: false,
    maxHeight: 400
  });

  //#endregion SystemSettings

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private elRef: ElementRef,
    @Inject(DOCUMENT) private document: Document) {

    if (!sessionStorage.getItem("tokenInfo")) {
      this.route.queryParams.subscribe(params => {
        var token = params["token"];
        if (!token) {
          this.router.navigate(['/account/login'], { relativeTo: this.route });
        } else {
          sessionStorage.setItem('tokenInfo', token);
        }
      });
    }

    
    //Yesterday Date
    var todayDate = new Date();
    todayDate.setDate(todayDate.getDate()-1);
    this.newcurrentDate = todayDate;
    this.yesterdayDate = this.newcurrentDate;

    var years = new Date().getFullYear();
    for (let year = years; year >= 2000; year--) {
      this.years.push(year);
    }
    this.getDetails(true);
    this.loadQuaterDropDown();
    this.dataAutoQueryTimer();
  }

  getYesterday() {
    var yesterdayDate = new Date();
    return this.datePipe.transform(yesterdayDate.setDate(yesterdayDate.getDate() - 1), 'yyyy-MM-dd');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenWidth = window.innerWidth;
  }


  buildChartLabelColor() {
    if (this.document.body.classList.contains("dark-theme")) {
      return "#FFFFFF";
    } else {
      return "#000000";
    }
  }

  ngOnDestroy(): void {
    if (this.timerValue) {
      clearInterval(this.timerValue);
    }
  }

  dataAutoQueryTimer() {
    this.timerValue = setInterval(() => {
      this.getDetails(false, false);
    }, 6000000);
  }

  assignMonth(controller, maxMonth: number, minStrMonth?: number) {
    this[controller] = [];
    for (var i = 0; i < 12; i++) {
      var m = monthList.filter(c => c.month == i + 1)[0];
      if (m.month <= maxMonth) {
        if (minStrMonth) {
          if (m.month >= minStrMonth) {
            this[controller].push(m);
          }
        }
        else {
          this[controller].push(m);
        }
      }
    }
  }

  monthList(maxMonth: number, minStrMonth?: number) {
    var monthS = [];
    for (var i = 0; i < 12; i++) {
      var m = monthList.filter(c => c.month == i + 1)[0];
      if (m.month <= maxMonth) {
        if (minStrMonth) {
          if (m.month >= minStrMonth) {
            monthS.push(m);
          }
        }
        else {
          monthS.push(m);
        }
      }
    }
    return monthS;
  }

  pageSizeChange(e) {
    this.chartDetails();
  }

  pageChange(e) {
    this.chartDetails();
  }

  chartDetails() {
    this.compileChartName();
    this.pageSize = this.pageSize || 10;
    this.startIndex = ((this.pageSize * this.page) - this.pageSize) + 1;
    this.totalRecords = this.chartDetailsData.length;
    this.endIndex = this.page * this.pageSize;
    this.chardDetailsDataList = this.chartDetailsData.slice(this.startIndex - 1, this.endIndex);
  }

  chartDetailsDetails(i) {
    this.showChartDetailsDetails[i] = !this.showChartDetailsDetails[i];
  }

  compileChartName() {
    if (this.groupingType === "month") {
      this.chartTitle = `Daily Crop (mt) Day ${monthList[this.selMonth - 1].desc}`;
      this.SubChartLabel = 'Day';
    } else if (this.groupingType === "range"||this.groupingType === "quarter") {
      this.chartTitle = `Monthly Crop (mt) Year ${this.selYear} from ${monthList[this.selMonthFrom - 1].desc} to ${monthList[this.selMonthTo - 1].desc}`;
      this.SubChartLabel = 'Month';
    }
    else {
      this.chartTitle = `Monthly Crop (mt) Year ${this.selYear}`;
      this.SubChartLabel = 'Month';
    }
  }

  buildLineOerKerChart(data) {

    data = data || this.chartData;
    this.chartData = data;
    if (!data.millCalculation.result?.millProductionChart) { return; }
    var seriesX: any[];
    var category = data.millCalculation.result.millProductionChart.filter(c => c.oerItems.length > 0).map((c) => c.header);
    if (!category) { return; };

    var oerList = data.millCalculation.result.millProductionChart.map((c) => c.oerTotal);
    var kerList = data.millCalculation.result.millProductionChart.map((c) => c.kerTotal);
    var budgetoerList = data.millCalculation.result.millProductionChart.map((c) => c.budgetOERTotal);
    var budgetkerList = data.millCalculation.result.millProductionChart.map((c) => c.budgetKERTotal);
    this.millProductivityOerKerChartData =[];
    this.millProductivityOerChartData =[];
    this.millProductivityOerChartData = data.millCalculation.result?.millProductionChart.oerItems;
    this.millProductivityKerChartData =[];
    this.millProductivityKerChartData = data.millCalculation.result?.millProductionChart.kerItems;
    this.millProductivityOerKerChartData = data.millCalculation.result?.millProductionChart;
    this.buildDashboardOerKerLineChart(oerList, category,kerList,budgetoerList,budgetkerList);
  }

  buildDashboardOerKerLineChart(oerList, category, kerList,budgetoerList,budgetkerList) {
    var dataSeries = oerList.map((data) => data);
    var productivitySeries = kerList.map((data)=> data);
    var dataSeries1 = budgetoerList.map((data) => data);
    var productivitySeries1 = budgetkerList.map((data)=> data);
    dataSeries.unshift("OER");
     productivitySeries.unshift("KER");
     dataSeries1.unshift("Budget OER");
     productivitySeries1.unshift("Budget KER");
    var initialZoomRange = this.getInitialRange(dataSeries);
    c3.generate({
      bindto: '#dashboardBarLineChartOerKer',
      title: {
        text: 'OER / KER Chart'
      },
      data: {
        columns: [
          dataSeries,
          productivitySeries,
          dataSeries1,
          productivitySeries1,
        ],
        type: 'bar',
        types: {
          'OER': 'spline',
          'KER': 'spline',
          'Budget OER': 'spline',
          'Budget KER': 'spline'
        }
      },
      axis: {
        y: {
          label: {
            text: 'Percentage (%)',
            position: 'outer-middle'
          }
        },
        x: {
          type: 'category',
          categories: category
        }
      },
      zoom: {
        enabled: true,
        rescale: true,
        initialRange: initialZoomRange ? [initialZoomRange[0], initialZoomRange[1]] : null
      }
    });
  }

  buildLineCpoPkChart(data) {

    data = data || this.chartData;
    this.chartData = data;
    if (!data.millCalculation.result?.millProductionChart) { return; }
    var seriesX: any[];
    var category = data.millCalculation.result.millProductionChart.filter(c => c.cpoItems.length > 0).map((c) => c.header);
    if (!category) { return; };

    var cpoList = data.millCalculation.result.millProductionChart.map((c) => c.cpoTotal);
    var pkList = data.millCalculation.result.millProductionChart.map((c) => c.pkTotal);
    
    var budgetcpoList = data.millCalculation.result.millProductionChart.map((c) => c.budgetCPOTotal);
    var budgetpkList = data.millCalculation.result.millProductionChart.map((c) => c.budgetPKTotal);
    this.millProductivityCpoPkChartData =[];
    this.millProductivityCpoPkChartData = data.millCalculation.result?.millProductionChart;
    this.buildDashboardCpoPkLineChart(cpoList, category,pkList,budgetcpoList,budgetpkList);
  }

  buildDashboardCpoPkLineChart(cpoList, category, pkList,budgetcpoList,budgetpkList) {
    var dataSeries = cpoList.map((data) => data);
    var productivitySeries = pkList.map((data)=> data);
    var dataSeries1 = budgetcpoList.map((data) => data);
    var productivitySeries1 = budgetpkList.map((data)=> data);
     dataSeries.unshift("CPO");
     productivitySeries.unshift("PK");
     dataSeries1.unshift("Budget CPO");
     productivitySeries1.unshift("Budget PK");
    var initialZoomRange = this.getInitialRange(dataSeries);
    c3.generate({
      bindto: '#dashboardBarLineChartCpoPk',
      title: {
        text: 'CPO / PK Chart'
      },
      data: {
        columns: [
          dataSeries,
          productivitySeries,
          dataSeries1,
          productivitySeries1,
        ],
        type: 'bar',
        types: {
          'CPO': 'spline',
          'PK': 'spline',
          'Budget CPO': 'spline',
          'Budget PK': 'spline'
        }
      },
      axis: {
        y: {
          label: {
            text: 'Productivity (mt)',
            position: 'outer-middle'
          }
        },
        x: {
          type: 'category',
          categories: category
        }
      },
      zoom: {
        enabled: true,
        rescale: true,
        initialRange: initialZoomRange ? [initialZoomRange[0], initialZoomRange[1]] : null
      }
    });
  }

  buildLineFfbChart(data) {

    data = data || this.chartData;
    this.chartData = data;
    if (!data.millCalculation.result?.millProductionChart) { return; }
    var seriesX: any[];
    var category = data.millCalculation.result.millProductionChart.filter(c => c.cpoItems.length > 0).map((c) => c.header);
    if (!category) { return; };
    var cpoList = data.millCalculation.result.millProductionChart.map((c) => c.cpoTotal);
    var pkList = data.millCalculation.result.millProductionChart.map((c) => c.pkTotal)
    var oerList = data.millCalculation.result.millProductionChart.map((c) => c.oerTotal);
    var kerList = data.millCalculation.result.millProductionChart.map((c) => c.kerTotal);
    var ffbPrcsList = data.millCalculation.result.millProductionChart.map((c) => c.ffbprcsTotal);
    var ffbRecList = data.millCalculation.result.millProductionChart.map((c) => c.ffbrecTotal);
    var budgetffbPrcsList = data.millCalculation.result.millProductionChart.map((c) => c.budgetFFBPRCSTotal);
    this.millProductivityFfbChartData =[];
    this.millProductivityFfbChartData = data.millCalculation.result?.millProductionChart;
    this.millProductivityFfbChartData1 =[];
    this.millProductivityFfbChartData1 = data.millCalculation.result?.millProductionChart.oerItems;
    this.buildDashboarfFfbLineChart(cpoList, category,pkList,oerList,kerList,ffbPrcsList,ffbRecList,budgetffbPrcsList);
  }

  buildDashboarfFfbLineChart(cpoList, category,pkList,oerList,kerList,ffbPrcsList,ffbRecList,budgetffbPrcsList) {
    var cpoSeries = cpoList.map((data) => data);
    var pkSeries = pkList.map((data)=> data);
    var oerSeries = oerList.map((data) => data);
    var kerSeries = kerList.map((data)=> data);
    var ffbPrcsSeries = ffbPrcsList.map((data) => data);
    var ffbRecSeries = ffbRecList.map((data)=> data);
    var budgetffbPrcsSeries = budgetffbPrcsList.map((data) => data);
    cpoSeries.unshift("CPO");
    pkSeries.unshift("PK");

    oerSeries.unshift("OER");
    kerSeries.unshift("KER");
    
    ffbPrcsSeries.unshift("FFB Processed");
    ffbRecSeries.unshift("FFB Received");
    budgetffbPrcsSeries.unshift("Budget FFB Processed");
    var initialZoomRange = this.getInitialRange(cpoSeries);
    c3.generate({
      bindto: '#dashboardBarLineChartFfb',
      title: {
        text: 'FFB Chart'
      },
      data: {
        columns: [
          cpoSeries,
          pkSeries,
          oerSeries,
          kerSeries,
          budgetffbPrcsSeries,
          ffbPrcsSeries,
          ffbRecSeries,
         
        ],
        type: 'bar',
        types: {
          'CPO': 'spline',
          'PK': 'spline',
          'OER': 'spline',
          'KER': 'spline',
          'Budget FFB Processed': 'spline',
          'FFB Processed': 'bar',
          'FFB Received': 'bar'
          
        },
        axes: {
          'CPO': 'y',
          'PK': 'y',
          'OER': 'y2',
          'KER': 'y2',
        }
      },
      axis: {
        y: {
          label: {
            text: 'Productivity (mt)',
            position: 'outer-middle'
          }
        },
        y2: {
          show: true,
          label: 'Percentage (%)'
        },
        x: {
          type: 'category',
          categories: category
        }
      },
      zoom: {
        enabled: true,
        rescale: true,
        initialRange: initialZoomRange ? [initialZoomRange[0], initialZoomRange[1]] : null
      }
    });
  }

  buildPieChart(data) {

    data = data || this.chartData;
    this.chartData = data;
    if (!data.millCalculation.result?.estateEntryChart) { return; }
    var seriesX: any[];
    var category = data.millCalculation.result.estateEntryChart.map(c => c.name);
    if (!category) { return; };

    this.millProducitivtyPieChartData =[];
    this.millProducitivtyPieChartData = data.millCalculation.result?.estateEntryChart;
    var dataList = data.millCalculation.result.estateEntryChart.map((e) => e.total);

    this.buildDashboardPieChart(dataList, category);
  }

  buildDashboardPieChart(dataList, category) {
    var dataSeries = dataList.map((data) => data);
    var initialZoomRange = this.getInitialRange(dataSeries);

    var columns =[
            ['Error', 72,15,11],
            ['Success', 58,42,5],
    ];

    c3.generate({
      bindto: '#dashboardPieChart',
      data: {
        columns: [
        ['Submit', dataSeries[0]],
        ['Draft', dataSeries[1]],
        ['Not-Submitted', dataSeries[2]]
        ],
        type: "pie",
        colors: { 
          'Submit': '#87AB69',
          'Draft': '#FFA500',
          'Not-Submitted': '#FF0000'
        },
      }, 
      zoom: {
        enabled: true,
        rescale: true,
        initialRange: initialZoomRange ? [initialZoomRange[0], initialZoomRange[1]] : null
      }
    });
  }

  getInitialRange(e) {
    if (this.screenWidth < 600) {
      if (e.length - 1 === 1) { return null }
      else if (this.groupingType === 'quarter') { return [0, 2] }
      return [0, 6];
    } else {
      return null;
    }
  }
  async filter(){
    if (this.operatingSelVal.length > 0) {
      if(this.compareData == true)
      {
        this.compareDate1ValChange = true;
        this.compareDate2ValChange = false;
        await this.getDetails();
        this.compareDate2ValChange = true;
        this.compareDate1ValChange = false;
        await this.getDetails();
      }
      this.getDetails();
    }
  }
  async getDetails(updateUnitList: boolean = false, showSpinner: boolean = true) {

    if (showSpinner) this.spinner.show();

    if (this.showSingle && this.operatingSelVal?.length === 0) {
      this.operatingSelVal.push(this.operatingSelSingleVal);
    }
    if (this.operatingSelVal && this.operatingSelVal?.length === 0) {
      this.operatingSelVal = null;
    }
    if(this.operatingSelVal?.length===1)
    {
      this.ismultipleou = false;
    }
    else
    {
      this.ismultipleou = true;
    }
    
    var obj = {
      OperatingUnitList: this.operatingSelVal || null,
      entryDate: null,
      month: null,
      year: null,
      mthrange: null
    };


    if (this.groupingType === 'day' && !this.compareData) {
      obj.entryDate = this.selDate;
      this.newcurrentDate =this.selDate;
    } else if (this.groupingType === 'month' && !this.compareData) {

      if (!this.selYear) { this.selYear = Number(this.datePipe.transform(new Date(), "yyyy")); }
      if (!this.selMonth) { this.selMonth = Number(this.datePipe.transform(new Date(), "MM")); }
      obj.month = this.datePipe.transform(new Date(this.selYear, this.selMonth - 1, 1), "yyyy-MM-dd");

    } else if (this.groupingType === 'year' && !this.compareData) {

      if (!this.selYear) { this.selYear = Number(this.datePipe.transform(new Date(), "yyyy")); }
      obj.year = this.datePipe.transform(new Date(this.selYear, 0, 1), "yyyy-MM-dd");

    } else if ((this.groupingType === 'range'||this.groupingType === 'quarter') && !this.compareData) {

      if (!this.selMonthFrom) { this.selMonthFrom = Number(this.datePipe.transform(new Date(), "MM")); }
      if (!this.selMonthTo) { this.selMonthTo = Number(this.datePipe.transform(new Date(), "MM")); }
      if (!this.selYear) { this.selYear = Number(this.datePipe.transform(new Date(), "yyyy")); }

      var monthFromDt = this.datePipe.transform(new Date(this.selYear, this.selMonthFrom - 1, 1), "yyyy-MM-dd");
      var monthToDt = this.datePipe.transform(new Date(this.selYear, this.selMonthTo - 1, 1), "yyyy-MM-dd");
      obj.mthrange = `${monthFromDt};${monthToDt}`;

    } else if (this.compareData) {
      obj = this.compileCompareObj(obj);
    };

    await this.apiService.post(`${this.apiPath}`, JSON.stringify(obj)).then((data: any) => {

      if (!this.compareData) {
        this.dailyMt = data.millCalculation.result.oer?.dailyOER;
        this.dailyBudget = data.millCalculation.result.oer?.dailyBudget;
        this.dailyVarPer = data.millCalculation.result.oer?.variance;
        this.dailyKER = data.millCalculation.result.ker?.dailyKER;
        this.dailyBudgetKER = data.millCalculation.result.ker?.dailyBudget;
        this.varianceKER = data.millCalculation.result.ker?.variance;
        this.dailyCpoProd = data.millCalculation.result.cpo?.cpoProd;
        this.dailyCpoBal = data.millCalculation.result.cpo?.cpobal;
        this.dailyPkProd = data.millCalculation.result.pk?.pkprod;
        this.dailyPkBal = data.millCalculation.result.pk?.pkbal;
        this.dailyFfbRecv = data.millCalculation.result.ffb?.ffbrecv;
        this.dailyFfbPrcss = data.millCalculation.result.ffb?.ffbprcss;
        this.dailyFfbBal = data.millCalculation.result.ffb?.ffbbal!== null ? data.millCalculation.result.ffb?.ffbbal : 0; //data.millCalculation.result.ffb?.ffbbal;
        this.StMillList = data.millCalculation.result.stList;
        this.DtMillList = data.millCalculation.result.dtList;
        this.kernalBunker = data.millCalculation.result.kernalBunker;
        this.cert_ffbreceived = data.millCalculation.result.ffb?.ffbrecV_CERT!== null ? data.millCalculation.result.ffb?.ffbrecV_CERT : 0;     
        this.noncert_ffbreceived = data.millCalculation.result.ffb?.fbrecV_nonCERT!== null ? data.millCalculation.result.ffb?.ffbrecV_nonCERT : 0; 
        this.cert_ffbreceivedpercent = data.millCalculation.result.ffb?.ffbrecV_CERTpercent!== null ? data.millCalculation.result.ffb?.ffbrecV_CERTpercent : 0;   
        this.noncert_ffbreceivedpercent = data.millCalculation.result.ffb?.ffbrecV_nonCERTpercent!== null ? data.millCalculation.result.ffb?.ffbrecV_nonCERTpercent : 0;        
        this.cert_CPOProduction = data.millCalculation.result.cpo?.cpoProd_CERT!== null ? data.millCalculation.result.cpo?.cpoProd_CERT : 0;
        this.noncert_CPOProduction = data.millCalculation.result.cpo?.cpoProd_nonCERT !== null ? data.millCalculation.result.cpo?.cpoProd_nonCERT : 0;
        this.cert_CPOBalance = data.millCalculation.result.cpo?.cpobaL_CERT!== null ? data.millCalculation.result.cpo?.cpobaL_CERT : 0;
        this.noncert_CPOBalance = data.millCalculation.result.cpo?.cpobaL_nonCERT!== null ? data.millCalculation.result.cpo?.cpobaL_nonCERT : 0;
        this.cert_PKProduction = data.millCalculation.result.pk?.pkproD_CERT!== null ? data.millCalculation.result.pk?.pkproD_CERT : 0;
        this.noncert_PKProduction = data.millCalculation.result.pk?.pkproD_nonCERT!== null ? data.millCalculation.result.pk?.pkproD_nonCERT : 0;
        this.cert_PKBalance = data.millCalculation.result.pk?.pkbaL_CERT!== null ? data.millCalculation.result.pk?.pkbaL_CERT : 0;
        this.noncert_PKBalance = data.millCalculation.result.pk?.pkbaL_nonCERT!== null ? data.millCalculation.result.pk?.pkbaL_nonCERT : 0;
        var st =0;
        var dt =0;
       this.StMillList.forEach(c => {
       
         st +=  parseFloat(c.mt);
        this.totalST =  st.toFixed(2);
      });
      this.DtMillList.forEach(c => {
        dt += parseFloat(c.mt);
        this.totalDT  = dt.toFixed(2);
      });
        //Monthly
        this.monthlyMt = data.millCalculation.result.monthly?.mtdCrop;
        this.monthlyBudget = data.millCalculation.result.monthly?.monthlyBudget;
        this.monthlyVarPer = data.millCalculation.result.monthly?.variancePercentage;
        this.monthlyVarMt = data.millCalculation.result.monthly?.variance;

        //Monthly
        this.monthlyMt = data.millCalculation.result.monthly?.mtdCrop;
        this.monthlyBudget = data.millCalculation.result.monthly?.monthlyBudget;
        this.monthlyVarPer = data.millCalculation.result.monthly?.variancePercentage;
        this.monthlyVarMt = data.millCalculation.result.monthly?.variance;

        //Yearly
        this.yearlyMt = data.millCalculation.result.yearly?.ytdCrop;
        this.yearlyBudget = data.millCalculation.result.yearly?.yearlyBudget;
        this.yearlyVarPer = data.millCalculation.result.yearly?.variancePercentage;
        this.yearlyVarMt = data.millCalculation.result.yearly?.variance;

        //YPH
        this.yphMt = data.millCalculation.result.hecDaily?.yphHectare;
        this.yphBudget = data.millCalculation.result.hecDaily?.dailyBudget;
        this.yphVarPer = data.millCalculation.result.hecDaily?.variancePercentage;
        this.yphVarMt = data.millCalculation.result.hecDaily?.variance;

        //YPH Day
        this.yphMDT = data.millCalculation.result.hecDaily?.yphHectare;
        this.yphMDTBudget = data.millCalculation.result.hecDaily?.dailyBudget;
        this.yphMDTVarPer = data.millCalculation.result.hecDaily?.variancePercentage;
        this.yphMDTVarMt = data.millCalculation.result.hecDaily?.variance;

        //YPHMDT Month
        this.yphMDTMonth = data.millCalculation.result.hecMth?.yphHectare;
        this.yphMDTMonthBudget = data.millCalculation.result.hecMth?.dailyBudget;
        this.yphMDTMonthVarPer = data.millCalculation.result.hecMth?.variancePercentage;
        this.yphMDTMonthVarMt = data.millCalculation.result.hecMth?.variance;

        //YPHMDT Year
        this.yphMDTYear = data.millCalculation.result.hecYrs?.yphHectare;
        this.yphMDTYearBudget = data.millCalculation.result.hecYrs?.dailyBudget;
        this.yphMDTYearVarPer = data.millCalculation.result.hecYrs?.variancePercentage;
        this.yphMDTYearVarMt = data.millCalculation.result.hecYrs?.variance;

        //Range
        if (this.groupingType === 'range'||this.groupingType === 'quarter') {
          this.yearlyMt = data.millCalculation.result.range?.ytdCrop;
          this.yearlyBudget = data.millCalculation.result.range?.yearlyBudget;
          this.yearlyVarPer = data.millCalculation.result.range?.variancePercentage;
          this.yearlyVarMt = data.millCalculation.result.range?.variance;
        }

        //HA
        this.haMt = data.millCalculation.result.mature_Hectare;
      }

      if (this.compareData && this.compareDate1ValChange) {
        this.daily1Mt = data.millCalculation.result.oer?.dailyOER;
        this.daily1Budget = data.millCalculation.result.oer?.dailyBudget;
        this.daily1VarPer = data.millCalculation.result.oer?.variance;
        this.daily1KERMt = data.millCalculation.result.ker?.dailyKER;
        this.daily1KERBudget = data.millCalculation.result.ker?.dailyBudget;
        this.daily1KERVarMt = data.millCalculation.result.ker?.variance;
        this.daily1cpoProd = data.millCalculation.result.cpo?.cpoProd;
        this.daily1cpoBal = data.millCalculation.result.cpo?.cpobal;
        this.daily1PkProd = data.millCalculation.result.pk?.pkprod;
        this.daily1PkBal = data.millCalculation.result.pk?.pkbal;

        this.daily1FfbRecv = data.millCalculation.result.ffb?.ffbrecv;
        this.daily1FfbPrcss = data.millCalculation.result.ffb?.ffbprcss;
        this.daily1FfbBal = data.millCalculation.result.ffb?.ffbbal;

        this.St1MillList = data.millCalculation.result.stList;
        this.Dt1MillList = data.millCalculation.result.dtList;
        this.daily1kernalBunker = data.millCalculation.result.kernalBunker;

        this.monthly1Mt = data.millCalculation.result.oer?.dailyOER;
        this.monthly1Budget = data.millCalculation.result.oer?.dailyBudget;
        this.monthly1VarPer = data.millCalculation.result.oer?.variance;
        this.monthly1KERMt = data.millCalculation.result.ker?.dailyKER;
        this.monthly1KERBudget = data.millCalculation.result.ker?.dailyBudget;
        this.monthly1KERVarMt = data.millCalculation.result.ker?.variance;
        this.monthly1cpoProd = data.millCalculation.result.cpo?.cpoProd;
        this.monthly1cpoBal = data.millCalculation.result.cpo?.cpobal;
        this.monthly1PkProd = data.millCalculation.result.pk?.pkprod;
        this.monthly1PkBal = data.millCalculation.result.pk?.pkbal;

        this.monthly1FfbRecv = data.millCalculation.result.ffb?.ffbrecv;
        this.monthly1FfbPrcss = data.millCalculation.result.ffb?.ffbprcss;
        this.monthly1FfbBal = data.millCalculation.result.ffb?.ffbbal;

        this.St1MillList = data.millCalculation.result.stList;
        this.Dt1MillList = data.millCalculation.result.dtList;
        this.monthly1kernalBunker = data.millCalculation.result.kernalBunker;


        if (this.groupingType === "range" || this.groupingType === "year"||this.groupingType === "quarter") {
        //Yearly
        this.yearly1Mt = data.millCalculation.result.oer?.dailyOER;
        this.yearly1Budget = data.millCalculation.result.oer?.dailyBudget;
        this.yearly1VarPer = data.millCalculation.result.oer?.variance;
        this.yearly1KERMt = data.millCalculation.result.ker?.dailyKER;
        this.yearly1KERBudget = data.millCalculation.result.ker?.dailyBudget;
        this.yearly1KERVarMt = data.millCalculation.result.ker?.variance;
        this.yearly1cpoProd = data.millCalculation.result.cpo?.cpoProd;
        this.yearly1cpoBal = data.millCalculation.result.cpo?.cpobal;
        this.yearly1PkProd = data.millCalculation.result.pk?.pkprod;
        this.yearly1PkBal = data.millCalculation.result.pk?.pkbal;

        this.yearly1FfbRecv = data.millCalculation.result.ffb?.ffbrecv;
        this.yearly1FfbPrcss = data.millCalculation.result.ffb?.ffbprcss;
        this.yearly1FfbBal = data.millCalculation.result.ffb?.ffbbal;

        this.St1MillList = data.millCalculation.result.stList;
        this.Dt1MillList = data.millCalculation.result.dtList;
        this.yearly1kernalBunker = data.millCalculation.result.kernalBunker;
        }
      }
      if (this.compareData && this.compareDate2ValChange) {
        this.daily2Mt = data.millCalculation.result.oer?.dailyOER;
        this.daily2Budget = data.millCalculation.result.oer?.dailyBudget;
        this.daily2VarPer = data.millCalculation.result.oer?.variance;
        this.daily2KERMt = data.millCalculation.result.ker?.dailyKER;
        this.daily2KERBudget = data.millCalculation.result.ker?.dailyBudget;
        this.daily2KERVarMt = data.millCalculation.result.ker?.variance;
        this.daily2cpoProd = data.millCalculation.result.cpo?.cpoProd;
        this.daily2cpoBal = data.millCalculation.result.cpo?.cpobal;
        this.daily2PkProd = data.millCalculation.result.pk?.pkprod;
        this.daily2PkBal = data.millCalculation.result.pk?.pkbal;
        this.daily2FfbRecv = data.millCalculation.result.ffb?.ffbrecv;
        this.daily2FfbPrcss = data.millCalculation.result.ffb?.ffbprcss;
        this.daily2FfbBal = data.millCalculation.result.ffb?.ffbbal;
        this.St2MillList = data.millCalculation.result.stList;
        this.Dt2MillList = data.millCalculation.result.dtList;
        this.daily2kernalBunker = data.millCalculation.result.kernalBunker;

        this.monthly2Mt = data.millCalculation.result.oer?.dailyOER;
        this.monthly2Budget = data.millCalculation.result.oer?.dailyBudget;
        this.monthly2VarPer = data.millCalculation.result.oer?.variance;
        this.monthly2KERMt = data.millCalculation.result.ker?.dailyKER;
        this.monthly2KERBudget = data.millCalculation.result.ker?.dailyBudget;
        this.monthly2KERVarMt = data.millCalculation.result.ker?.variance;
        this.monthly2cpoProd = data.millCalculation.result.cpo?.cpoProd;
        this.monthly2cpoBal = data.millCalculation.result.cpo?.cpobal;
        this.monthly2PkProd = data.millCalculation.result.pk?.pkprod;
        this.monthly2PkBal = data.millCalculation.result.pk?.pkbal;
  
        this.monthly2FfbRecv = data.millCalculation.result.ffb?.ffbrecv;
        this.monthly2FfbPrcss = data.millCalculation.result.ffb?.ffbprcss;
        this.monthly2FfbBal = data.millCalculation.result.ffb?.ffbbal;

        this.St2MillList = data.millCalculation.result.stList;
        this.Dt2MillList = data.millCalculation.result.dtList;
        this.monthly2kernalBunker = data.millCalculation.result.kernalBunker;

        if (this.groupingType === "range" || this.groupingType === "year"||this.groupingType === "quarter") {
          this.yearly2Mt = data.millCalculation.result.oer?.dailyOER;
          this.yearly2Budget = data.millCalculation.result.oer?.dailyBudget;
          this.yearly2VarPer = data.millCalculation.result.oer?.variance;
          this.yearly2KERMt = data.millCalculation.result.ker?.dailyKER;
          this.yearly2KERBudget = data.millCalculation.result.ker?.dailyBudget;
          this.yearly2KERVarMt = data.millCalculation.result.ker?.variance;
          this.yearly2cpoProd = data.millCalculation.result.cpo?.cpoProd;
          this.yearly2cpoBal = data.millCalculation.result.cpo?.cpobal;
          this.yearly2PkProd = data.millCalculation.result.pk?.pkprod;
          this.yearly2PkBal = data.millCalculation.result.pk?.pkbal;

          this.yearly2FfbRecv = data.millCalculation.result.ffb?.ffbrecv;
          this.yearly2FfbPrcss = data.millCalculation.result.ffb?.ffbprcss;
          this.yearly2FfbBal = data.millCalculation.result.ffb?.ffbbal;

          this.St2MillList = data.millCalculation.result.stList;
          this.Dt2MillList = data.millCalculation.result.dtList;
          this.yearly2kernalBunker = data.millCalculation.result.kernalBunker;
        }
        else {
          //Yearly
          this.yearly2Mt = data.millCalculation.result.yearly?.ytdCrop;
          this.yearly2Budget = data.millCalculation.result.yearly?.yearlyBudget;
          this.yearly2VarPer = data.millCalculation.result.yearly?.variance;
        }
      }
      if (updateUnitList) {
        this.compoundTreeList(data.operatingUnitList);
      }

      if(this.groupingType === 'day') {
        this.buildPieChart(data);
      }

      if (this.groupingType === 'month') {
        this.buildLineOerKerChart(data);
        this.buildLineCpoPkChart(data);
        this.buildLineFfbChart(data);
        this.chartDetails();
      }
      if (this.groupingType === 'year') {
        this.buildLineOerKerChart(data);
        this.buildLineCpoPkChart(data);
        this.buildLineFfbChart(data);
        this.chartDetails();
      }
      if (this.groupingType === 'range') {
        this.buildLineOerKerChart(data);
        this.buildLineCpoPkChart(data);
        this.buildLineFfbChart(data);
        this.chartDetails();
      }
      if (this.groupingType === 'quarter') {
        this.buildLineOerKerChart(data);
        this.buildLineCpoPkChart(data);
        this.buildLineFfbChart(data);
        this.chartDetails();
      }

      this.spinner.hide();
    }).catch(error => {
      this.spinner.hide();
      //Swal.fire("Error!", error.error, "error");
    });
  }

  compoundTreeList(data) {
    var ouCount = 0;
    this.operatingUnitList = [];
    data.cropMasterRegionList.forEach(c => {
      var bu = [];
      c.businessList.forEach(d => {
        var ou = [];
        d.operatingUnitList.forEach(e => {
          ou.push(new TreeviewItem({ text: e.name, value: e.guid }));
          ouCount += 1;
        });
        bu.push(new TreeviewItem({ text: d.name, value: null, children: ou }));
      });
      var region = new TreeviewItem({ text: c.name, value: null, children: bu });
      this.operatingUnitList.push(region);
    });


    this.showSingle = ouCount === 1;
    if (this.showSingle) {
      this.operatingSelSingleVal = data?.cropMasterRegionList[0].businessList[0].operatingUnitList[0].guid;
    }
  }

  @ViewChild('dll') dll: ElementRef;
  ngAfterViewInit() {
    this.screenWidth = window.innerWidth;
  }


  async updateOperating(e) {
    this.operatingSelVal = [];
    e.forEach(c => {
      this.operatingSelVal.push(c);
    })
    
  }

  compileCompareObj(obj) {

    if (this.groupingType === "day") {
      obj.entryDate = this.compareDate1ValChange ? this.compareDate1 : this.compareDate2;
    }

    if (this.groupingType === "month") {
      var selYear = this.compareDate1ValChange ? this.compareYearSel1 : this.compareYearSel2;
      var selMonth = this.compareDate1ValChange ? this.compareMonthSel1 : this.compareMonthSel2;
      selYear = selYear || Number(this.datePipe.transform(new Date(), "yyyy"));
      selMonth = selMonth || Number(this.datePipe.transform(new Date(), "MM"));
      obj.month = this.datePipe.transform(new Date(selYear, selMonth - 1, 1), "yyyy-MM-dd");
    }

    if (this.groupingType === 'year') {

      var selYear = this.compareDate1ValChange ? this.compareYearSel1 : this.compareYearSel2;
      selYear = selYear || Number(this.datePipe.transform(new Date(), "yyyy"));
      obj.year = this.datePipe.transform(new Date(selYear, 0, 1), "yyyy-MM-dd");
    }

    if (this.groupingType === 'range') {

      var selYear = this.compareDate1ValChange ? this.compareYearSel1 : this.compareYearSel2;
      var selMonthFrom = this.compareDate1ValChange ? this.compareMonthFromSel1 : this.compareMonthFromSel2;
      var selMonthTo = this.compareDate1ValChange ? this.compareMonthToSel1 : this.compareMonthToSel2;
      selYear = selYear || Number(this.datePipe.transform(new Date(), "yyyy"));
      selMonthFrom = selMonthFrom || Number(this.datePipe.transform(new Date(), "MM"));
      selMonthTo = selMonthTo || Number(this.datePipe.transform(new Date(), "MM"));

      var monthFromDt = this.datePipe.transform(new Date(selYear, selMonthFrom - 1, 1), "yyyy-MM-dd");
      var monthToDt = this.datePipe.transform(new Date(selYear, selMonthTo - 1, 1), "yyyy-MM-dd");
      obj.mthrange = `${monthFromDt};${monthToDt}`;
    }
    if (this.groupingType === 'quarter')
    {
      var selYear = this.compareDate1ValChange ? this.compareYearSel1 : this.compareYearSel2;
      selYear = selYear || Number(this.datePipe.transform(new Date(), "yyyy"));
      var quarterlist = this.compareDate1ValChange ? this.compareQuarter1.split('-') : this.compareQuarter2.split('-');
      this.selMonthFrom = Number(quarterlist[0]);
      this.selMonthTo = Number(quarterlist[1]);
      var monthFromDt = this.datePipe.transform(new Date(selYear, this.selMonthFrom - 1, 1), "yyyy-MM-dd");
      var monthToDt = this.datePipe.transform(new Date(selYear,  this.selMonthTo - 1, 1), "yyyy-MM-dd");
      obj.mthrange = `${monthFromDt};${monthToDt}`;
    }

    return obj;
  }

  openComparison() {
    this.compareDate1 = this.selDate;
    this.compareDate2 = this.selDate;
    this.compareData = true;

    this.compareDate1ValChange = true;
    this.compareDate2ValChange = true;
    this.getDetails();
    this.loadQuaterDropDown();
  }

  closedComparison() {
    this.compareData = false;
    this.compareDate1ValChange = false;
    this.compareDate2ValChange = false;
    this.getDetails();
  }

  filterDay() {
    this.groupingType = "day";
    this.chartDateSel = 0;
    this.compareDate1ValChange = true;
    this.compareDate2ValChange = true;
    this.selDate =this.getYesterday();
    this.getDetails();
  }

  filterMonth() {
    this.groupingType = "month";
    this.chartDateSel = 0;
    this.compareDate1ValChange = true;
    this.compareDate2ValChange = true;
    
  
    if (this.selYear < (new Date()).getFullYear()) {
     this.assignMonth("months", 12);
    }
    else {
      //if date is 1 get until previous month
      if(Number(this.datePipe.transform(new Date(), 'dd')) == 1){
        this.assignMonth("months", Number(this.datePipe.transform(new Date(), 'MM')) - 1);
        this.selMonthData = Number(this.datePipe.transform(new Date(), 'MM')) -1;
      }
      else{
       this.assignMonth("months", Number(this.datePipe.transform(new Date(), 'MM')));
       this.selMonthData = Number(this.datePipe.transform(new Date(), 'MM'));
      }
    }
    this.chartTitle = `Daily Crop (mt) Day ${monthList[this.selMonth - 1].desc}`;

    this.getDetails();
    //this.selMonth = Number(this.datePipe.transform(new Date(), 'MM'));
    this.selMonth = Number(this.selMonthData);
    var dateLabel = this.dateList[this.chartDateSel];
    this.cartSelLabel = "Days";
  }

  filterYear() {
    this.groupingType = "year";
    this.chartDateSel = 0;
    this.compareDate1ValChange = true;
    this.compareDate2ValChange = true;
    this.getDetails();
    this.chartTitle = `Monthly Crop (mt) Year ${this.selYear}`;
    this.cartSelLabel = "Months";

    this.compareYearSel1 = Number(this.datePipe.transform(new Date(), 'YYYY'));
    this.compareYearSel2 = Number(this.datePipe.transform(new Date(), 'YYYY'));
  }

  selMonthFromChange() {
    var curYear = Number(this.datePipe.transform(new Date(), "YYYY"));
    var fromMonth = Number(this.selMonthFrom);
    var year = Number(this.selYear);
    this.chartDateSel = 0;
    if (year < curYear) {
      this.assignMonth("monthsTo", 12, Number(this.selMonthFrom));
      if (this.selMonthTo < this.selMonthFrom) {
        this.selMonthTo = this.selMonthFrom;
      };
    }
    else {
      if (Number(this.selMonthTo) < fromMonth) {
        this.selMonthTo = fromMonth;
      }
      this.assignMonth("monthsTo", Number(this.datePipe.transform(new Date(), 'MM')), Number(this.selMonthFrom));
    }
    //this.getDetails();
    this.chartTitle = `Monthly Crop (mt) Year ${this.selYear} From ${monthList[this.selMonthFrom - 1].alpha} to ${monthList[this.selMonthTo - 1].alpha}`;
  }

  selMonthFromCompareChange(compare1) {

    this.compareDate1ValChange = false;
    this.compareDate2ValChange = false;
    var curYear = Number(this.datePipe.transform(new Date(), "YYYY"));
    if (compare1) {
      this.compareDate1ValChange = true;
      var fromMonth = Number(this.compareMonthFromSel1);
      var year = Number(this.compareYearSel1);
      if (year < curYear) {
        this.assignMonth("compareMonthsTo1", 12, Number(this.compareMonthFromSel1));
        if (this.compareMonthToSel1 < this.compareMonthFromSel1) {
          this.compareMonthToSel1 = this.compareMonthFromSel1;
        };
      }
      else {
        if (Number(this.compareMonthToSel1) < fromMonth) {
          this.compareMonthToSel1 = fromMonth;
        }
        this.assignMonth("compareMonthsTo1", Number(this.datePipe.transform(new Date(), 'MM')), Number(this.compareMonthFromSel1));
      }
    } else {
      this.compareDate2ValChange = true;
      var fromMonth = Number(this.compareMonthFromSel2);
      var year = Number(this.compareYearSel2);
      if (year < curYear) {
        this.assignMonth("compareMonthsTo2", 12, Number(this.compareMonthFromSel2));
        if (this.compareMonthToSel2 < this.compareMonthFromSel2) {
          this.compareMonthToSel2 = this.compareMonthFromSel2;
        };
      }
      else {
        if (Number(this.compareMonthToSel2) < fromMonth) {
          this.compareMonthToSel2 = fromMonth;
        }
        this.assignMonth("compareMonthsTo2", Number(this.datePipe.transform(new Date(), 'MM')), Number(this.compareMonthFromSel2));
      }
    }
    //this.getDetails();
  }


  selMonthToChange() {
    this.chartDateSel = 0;
    //this.getDetails();
    this.chartTitle = `Monthly Crop (mt) Year ${this.selYear} From ${monthList[this.selMonthFrom - 1].alpha} to ${monthList[this.selMonthTo - 1].alpha}`;
  }

  selYearChange() {
    if (this.groupingType === "month") {
      var year = Number(this.selYear);
      var curYear = Number(this.datePipe.transform(new Date(), "YYYY"));
      if (year < curYear) {
        this.assignMonth("months", 12);
      }
      else {
        this.assignMonth("months", Number(this.datePipe.transform(new Date(), "MM")));
        this.selMonth = Number(this.datePipe.transform(new Date(), "MM"));
      }
    }
    else if (this.groupingType === "range"||this.groupingType === "quarter") {
      var year = Number(this.selYear);
      var curYear = Number(this.datePipe.transform(new Date(), "YYYY"));
      if (year < curYear) {
        this.assignMonth("monthsFrom", 12);
        this.selMonthFrom = Number(this.datePipe.transform(new Date(), "MM"));
        this.assignMonth("monthsTo", 12, Number(this.selMonthFrom));
        this.selMonthTo = Number(this.datePipe.transform(new Date(), "MM"));
      }
      else {
        this.assignMonth("monthsFrom", Number(this.datePipe.transform(new Date(), "MM")));
        this.selMonthFrom = Number(this.datePipe.transform(new Date(), "MM"));
        this.assignMonth("monthsTo", Number(this.datePipe.transform(new Date(), 'MM')), Number(this.selMonthFrom));
        this.selMonthTo = Number(this.datePipe.transform(new Date(), "MM"));
      }
    }
    //this.getDetails();
  }

  selYearChangeCom(compare1: boolean = false) {
    var curYear = Number(this.datePipe.transform(new Date(), "YYYY"));
    var MonthCtr = compare1 ? "compareMonths1" : "compareMonths2";
    var MonthFromCtr = compare1 ? "compareMonthsFrom1" : "compareMonthsFrom2";
    var MonthToCtr = compare1 ? "compareMonthsTo1" : "compareMonthsTo2";
    var selYear = compare1 ? this.compareYearSel1 : this.compareYearSel2;
    var selMonth = compare1 ? this.compareMonthSel1 : this.compareMonthSel2;
    var selFromMonth = compare1 ? this.compareMonthFromSel1 : this.compareMonthFromSel1;
    var selFromTo = compare1 ? this.compareMonthToSel1 : this.compareMonthToSel2;
    var year = Number(selYear);

    this.compareDate1ValChange = compare1;
    this.compareDate2ValChange = !compare1;

    if (this.groupingType === "month") {

      if (year < curYear) {
        this.assignMonth(MonthCtr, 12);
      }
      else {
        this.assignMonth(MonthCtr, Number(this.datePipe.transform(new Date(), "MM")));
        selMonth = Number(this.datePipe.transform(new Date(), "MM"));
      }
    }
    else if (this.groupingType === "range"||this.groupingType === "quarter") {
      if (year < curYear) {
        this.assignMonth(MonthFromCtr, 12);
        selFromMonth = Number(this.datePipe.transform(new Date(), "MM"));
        this.assignMonth(MonthToCtr, 12, Number(this.selMonthFrom));
        selFromTo = Number(this.datePipe.transform(new Date(), "MM"));
      }
      else {
        this.assignMonth(MonthFromCtr, Number(this.datePipe.transform(new Date(), "MM")));
        selFromMonth = Number(this.datePipe.transform(new Date(), "MM"));
        this.assignMonth(MonthToCtr, Number(this.datePipe.transform(new Date(), 'MM')), Number(this.selMonthFrom));
        selFromTo = Number(this.datePipe.transform(new Date(), "MM"));
      }
    }
   // this.getDetails();
  }

  filterRange() {
    this.groupingType = "range";
    if (this.compareData) {
      this.compareMonthFromSel1 = Number(this.datePipe.transform(new Date(), 'MM'));
      this.compareMonthToSel1 = Number(this.datePipe.transform(new Date(), 'MM'));

      this.compareMonthFromSel2 = Number(this.datePipe.transform(new Date(), 'MM'));
      this.compareMonthToSel2 = Number(this.datePipe.transform(new Date(), 'MM'));

      this.compareYearSel1 = Number(this.datePipe.transform(new Date(), 'YYYY'));
      this.compareYearSel2 = Number(this.datePipe.transform(new Date(), 'YYYY'));

      this.compareDate1ValChange = true;
      this.compareDate2ValChange = true;
      this.getDetails();
    }
    else {
      this.chartDateSel = 0;
      // this.selMonthFrom = Number(this.datePipe.transform(new Date(), 'MM'));
      // this.selMonthTo = Number(this.datePipe.transform(new Date(), 'MM'));

      if (this.selYear < (new Date()).getFullYear()) {
        this.assignMonth("monthsFrom", 12);
        this.assignMonth("monthsTo", 12, Number(this.selMonthFrom));
      }
      else {        
        if (Number(this.datePipe.transform(new Date(), 'dd')) == 1) {
          this.selMonthFrom = Number(this.datePipe.transform(new Date().setDate(-1), 'MM'));
          this.selMonthTo = Number(this.datePipe.transform(new Date().setDate(-1), 'MM'));
          this.assignMonth("monthsFrom", Number(this.datePipe.transform(new Date(), 'MM')) - 1);
          this.assignMonth("monthsTo", Number(this.datePipe.transform(new Date(), 'MM')) - 1, Number(this.selMonthFrom));
        }
        else {
          this.selMonthFrom = Number(this.datePipe.transform(new Date(), 'MM'));
          this.selMonthTo = Number(this.datePipe.transform(new Date(), 'MM'));
          this.assignMonth("monthsFrom", Number(this.datePipe.transform(new Date(), 'MM')));
          this.assignMonth("monthsTo", Number(this.datePipe.transform(new Date(), 'MM')), Number(this.selMonthFrom));
        }

        // this.assignMonth("monthsFrom", Number(this.datePipe.transform(new Date(), 'MM')));
        // this.assignMonth("monthsTo", Number(this.datePipe.transform(new Date(), 'MM')), Number(this.selMonthFrom));
      }

      this.getDetails();
      var frmMonth: any;
      var toMonth: any;
      
      //var frmMonth = this.datePipe.transform(new Date(), 'MMM');
      if (Number(this.datePipe.transform(new Date(), 'dd')) == 1) {
        frmMonth = this.datePipe.transform(new Date().setDate(-1), 'MMM');
        toMonth = this.datePipe.transform(new Date().setDate(-1), 'MMM');
      }
      else {   
        frmMonth = this.datePipe.transform(new Date(), 'MMM');
        toMonth = this.datePipe.transform(new Date(), 'MMM');
      }
      this.chartTitle = `Monthly Crop (mt) Year ${this.selYear} From ${frmMonth} to ${toMonth}`;
      this.cartSelLabel = "Months";
    }
  }
  filterQuarter() {
    this.groupingType = "quarter";
    if (this.compareData) {
      this.compareMonthFromSel1 = Number(this.datePipe.transform(new Date(), 'MM'));
      this.compareMonthToSel1 = Number(this.datePipe.transform(new Date(), 'MM'));

      this.compareMonthFromSel2 = Number(this.datePipe.transform(new Date(), 'MM'));
      this.compareMonthToSel2 = Number(this.datePipe.transform(new Date(), 'MM'));

      this.compareYearSel1 = Number(this.datePipe.transform(new Date(), 'YYYY'));
      this.compareYearSel2 = Number(this.datePipe.transform(new Date(), 'YYYY'));

      this.compareDate1ValChange = true;
      this.compareDate2ValChange = true;
      this.getDetails();
      this.loadQuaterDropDown();
    }
    else {
      this.chartDateSel = 0;
      this.loadQuaterDropDown();
      var quarterlist = this.selectedQuarter.split('-');
      this.selMonthFrom = Number(quarterlist[0]);
      this.selMonthTo = Number(quarterlist[1]);
      this.getDetails();
      this.loadQuaterDropDown();
      this.chartTitle = `Monthly Crop (mt) Year ${this.selYear} From ${monthList[this.selMonthFrom - 1].alpha} to ${monthList[this.selMonthTo - 1].alpha}`;
      this.cartSelLabel = "Months";
    }
  }
  //kelvin 30/11/2022
  selQuarterChange() {
    var quarterlist = this.selectedQuarter.split('-');
    this.selMonthFrom = Number(quarterlist[0]);
    this.selMonthTo = Number(quarterlist[1]);
    this.chartDateSel = 0;
    //this.getDetails();
    this.chartTitle = `Monthly Crop (mt) Year ${this.selYear} From ${monthList[this.selMonthFrom - 1].alpha} to ${monthList[this.selMonthTo - 1].alpha}`;
  }
  compareDate1Change() {
    this.compareDate1ValChange = true;
    this.compareDate2ValChange = false;
    //this.getDetails();
  }

  compareYearChange(compare1: boolean) {
    if (this.groupingType === "month") {
      var year = Number(compare1 ? this.compareYearSel1 : this.compareYearSel2);
      var curYear = Number(this.datePipe.transform(new Date(), "YYYY"));
      if (year < curYear) {
        this.assignMonth(compare1 ? "compareMonths1" : "compareMonths2", 12);
      }
      else {
        if (compare1) {
          this.assignMonth("compareMonths1", Number(this.datePipe.transform(new Date(), "MM")));
          this.compareMonthSel1 = Number(this.datePipe.transform(new Date(), "MM"));
        } else {
          this.assignMonth("compareMonths2", Number(this.datePipe.transform(new Date(), "MM")));
          this.compareMonthSel2 = Number(this.datePipe.transform(new Date(), "MM"));
        }
      }
    }
    else if (this.groupingType === "range") {
      var curYear = Number(this.datePipe.transform(new Date(), "YYYY"));
      if (compare1) {
        var year = Number(this.compareYearSel1);
        if (year < curYear) {
          this.assignMonth("compareMonthsFrom1", 12);
          this.compareMonthFromSel1 = Number(this.datePipe.transform(new Date(), "MM"));
          this.assignMonth("compareMonthsTo1", 12, Number(this.compareMonthFromSel1));
          this.compareMonthToSel1 = Number(this.datePipe.transform(new Date(), "MM"));
        }
        else {
          this.assignMonth("compareMonthsFrom1", Number(this.datePipe.transform(new Date(), "MM")));
          this.compareMonthFromSel1 = Number(this.datePipe.transform(new Date(), "MM"));
          this.assignMonth("compareMonthsTo1", Number(this.datePipe.transform(new Date(), 'MM')), Number(this.compareMonthFromSel1));
          this.compareMonthToSel1 = Number(this.datePipe.transform(new Date(), "MM"));
        }
      }
      else {
        var year = Number(this.compareYearSel2);
        if (year < curYear) {
          this.assignMonth("compareMonthsFrom2", 12);
          this.compareMonthFromSel2 = Number(this.datePipe.transform(new Date(), "MM"));
          this.assignMonth("compareMonthsTo2", 12, Number(this.compareMonthFromSel1));
          this.compareMonthToSel2 = Number(this.datePipe.transform(new Date(), "MM"));
        }
        else {
          this.assignMonth("compareMonthsFrom2", Number(this.datePipe.transform(new Date(), "MM")));
          this.compareMonthFromSel2 = Number(this.datePipe.transform(new Date(), "MM"));
          this.assignMonth("compareMonthsTo2", Number(this.datePipe.transform(new Date(), 'MM')), Number(this.compareMonthFromSel2));
          this.compareMonthToSel2 = Number(this.datePipe.transform(new Date(), "MM"));
        }
      }
    }
    //this.getDetails();
  }

  compareDate2Change() {
    this.compareDate1ValChange = false;
    this.compareDate2ValChange = true;
   // this.getDetails();
  }
  loadQuaterDropDown() {
    this.apiService.get(`${this.appSettings.apiPath.crop}/api/dashboard/getDashboardQuaterDdl`).then((data: any) => {
      this.QuaterList = data;
      this.selectedQuarter = data[0].value;
      this.compareQuarter1 = data[0].value;
      this.compareQuarter2 = data[0].value;
    }).catch(error => {
    })
  }
  
}


let monthList = [
  { "month": 1, "desc": "January", "alpha": "Jan" },
  { "month": 2, "desc": "February", "alpha": "Feb" },
  { "month": 3, "desc": "March", "alpha": "Mar" },
  { "month": 4, "desc": "April", "alpha": "Apr" },
  { "month": 5, "desc": "May", "alpha": "May" },
  { "month": 6, "desc": "June", "alpha": "Jun" },
  { "month": 7, "desc": "July", "alpha": "Jul" },
  { "month": 8, "desc": "August", "alpha": "Aug" },
  { "month": 9, "desc": "September", "alpha": "Sep" },
  { "month": 10, "desc": "October", "alpha": "Oct" },
  { "month": 11, "desc": "November", "alpha": "Nov" },
  { "month": 12, "desc": "December", "alpha": "Dec" }
]


